import { CheckCircle2, ClipboardCheck, Radio, AlertTriangle } from "lucide-react";
import { cn } from "@/lib/utils";

export function UnreadDot({ n, testid }) {
  if (!n) return null;
  return (
    <span className="relative inline-flex" data-testid={testid}>
      <span className="absolute inset-0 rounded-full bg-red-500 animate-ping opacity-60" />
      <span className="relative min-w-[18px] h-[18px] rounded-full bg-red-600 text-white text-[10px] font-black grid place-items-center px-1 tnum">{n}</span>
    </span>
  );
}

// Üst çubukta kompakt: canlı hazırlık listesine gönder / bağlı listenin canlı durumu (sepet alanını daraltmaz)
export function LivePrepChip({ prep, canSend, onSend, onOpen }) {
  if (!prep) {
    return (
      <button type="button" onClick={onSend} disabled={!canSend} title="Hazırlanacak listeye gönder — ödeme beklenmez, sepetteki her değişiklik depoya anında yansır"
        className="inline-flex h-9 items-center gap-1.5 rounded-xl border border-dashed border-violet-400/70 bg-violet-500/[0.07] px-2.5 text-xs font-bold text-violet-800 dark:text-violet-200 transition-all hover:bg-violet-500/15 active:scale-95 disabled:opacity-50"
        data-testid="qs-send-prep-live">
        <ClipboardCheck className="h-4 w-4 text-violet-600" />
        <span className="hidden xl:inline whitespace-nowrap">Hazırlığa Gönder</span>
        <span className="rounded bg-red-600 text-white text-[8.5px] font-black px-1 py-px tracking-wider">CANLI</span>
      </button>
    );
  }
  const done = prep.status === "tamamlandi";
  const tip = [`${prep.assigned_name} · ${prep.quote_no}`, done ? "Hazırlandı" : `${prep.prepared}/${prep.total} hazır`, prep.pending_changes > 0 ? `${prep.pending_changes} değişiklik depoda görülmedi` : ""].filter(Boolean).join(" · ");
  return (
    <button type="button" onClick={onOpen} title={tip}
      className={cn("relative inline-flex h-9 items-center gap-1.5 rounded-xl border px-2.5 text-xs font-bold transition-all active:scale-95",
        done ? "border-emerald-500/50 bg-emerald-500/10 text-emerald-700 dark:text-emerald-300" : "border-violet-400/60 bg-violet-500/[0.08] text-foreground hover:bg-violet-500/15")}
      data-testid="qs-live-prep-bar">
      <span className="relative">
        <ClipboardCheck className={cn("h-4 w-4", done ? "text-emerald-600" : "text-[#EA5820]")} />
        {!done && <span className="absolute -top-1 -right-1 h-2 w-2 rounded-full bg-red-500 animate-pulse ring-2 ring-card" />}
      </span>
      <span className="hidden xl:inline-flex items-center gap-1 text-[10px] font-black uppercase tracking-wider text-red-600"><Radio className="h-3 w-3" />Hazırlık</span>
      {done ? <span className="inline-flex items-center gap-0.5 rounded-full bg-emerald-600 text-white px-1.5 py-px text-[10px]" data-testid="qs-live-prep-done"><CheckCircle2 className="h-3 w-3" />Hazırlandı ✓</span>
        : <span className="rounded-full bg-sky-600 text-white px-1.5 py-px text-[10px] tnum" data-testid="qs-live-prep-progress">{prep.prepared}/{prep.total}</span>}
      {prep.pending_changes > 0 && <span className="inline-flex items-center gap-0.5 rounded-full bg-amber-500 text-white px-1.5 py-px text-[10px] tnum" data-testid="qs-live-prep-pending"><AlertTriangle className="h-3 w-3" />{prep.pending_changes}</span>}
    </button>
  );
}
